<div *ngIf="showGallery || enableUpload">
    <div class='form-group row '>
        <label class="col-sm-2 col-form-label gradient-effect">{{'simple-travel-form.label.gallery' | translate}}</label>
        <div class='col-sm-10 '>
            <div class="carousel slide media-carousel gallery" *ngIf="showGallery" id="media">
                <div class="carousel-inner">
                    <div class="item" [ngClass]="{active: counter === 0} " *ngFor="let image of imagesArray, let counter= index">
                        <div class="row">
                            <div class="col-md-4" *ngFor="let img of imagesArray[counter], let i = index">
                                <a class="thumbnail gradient-effect">
                                    <label>{{'simple-travel-form.label.gallery-main' | translate}}</label>
                                    <input type="radio" name="optradio" [checked]="img.main == true" [value]="true" (change)="changeImageMainPriperty(img.assignment)" />
                                    <img alt="" src='{{imageUrl(tenantCode,img.id)}}'>
                                    <button class="btn delete-travel" (click)="deleteImage(img.assignment)">{{'simple-travel-form.label.gallery-delete' | translate}}</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <a data-slide="prev" href="#media" class="left carousel-control">‹</a>
                <a data-slide="next" href="#media" class="right carousel-control">›</a>
            </div>
            <div *ngIf="enableUpload" class="gallery">
                <div class="col-sm-6">
                    <!-- <button class="btn" (click)="openChooseFileDialog()">Add image</button> -->
                    <a class="btn delete-travel">
                        <i class="fa fa-upload" (click)="openChooseFileDialog()"> &nbsp;{{'simple-travel-form.label.image-upload' | translate}}</i>
                    </a>
                </div>

                <input type="file" hidden accept=".jpg, .png, .gif" id="input-for-file" class="col-sm-6" (change)="fileChangeEvent($event)" />
                <button type="button" class="btn new-travel" hidden="true" (click)="uploadImageFunction(croppedImage, data)" name="button-upload" id="button-upload">{{'simple-travel-form.label.upload' | translate}}</button>
                <image-cropper (loadImageFailed)="loadImageFailed($event)" format="jpeg" [maintainAspectRatio]="false" [imageChangedEvent]="imageChangedEvent" id="image-cropper" (imageCropped)="imageCropped($event)"></image-cropper>

                <img hidden="true" id="cropped-immage" [src]="croppedImage" />
                <!-- <div class="col-sm-6">
                    <img-cropper [image]="data" #fileInput [settings]="cropperSettings1"></img-cropper>
                </div>
                <div class="col-sm-6 ">
                    <button type="button" class="btn new-travel" (click)="uploadImageFunction(data.image, data)" name="button-upload" id="button-upload">{{'simple-travel-form.label.upload' | translate}}</button>
                    <span class="result" *ngIf="data.image">
                  <img [src]="data.image"
                  [width]="cropperSettings1.croppedWidth"
                  [height]="cropperSettings1.croppedHeight">
              </span>
                </div> -->
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/image.upload.html